// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"d6b2030a","425":"131f4907","510":"09794ef3","532":"414d80e7","633":"a38a1a0d","634":"4fb4f38f","922":"298be8b8","937":"1f9c7985","972":"2b2a30f5"}[chunkId] + ".chunk.js";
};